import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { IGrowthRatesSave } from './growth-rates-save';

import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class GrowthRatesSaveService {

    //need to have this somewhere besides hardcoded in here
    //private _growthRatesSaveUrl = `http://localhost:55706/api/systemmanagement/GrowthRatesSave`;
    private _growthRatesSaveUrl = `api/systemmanagement/GrowthRatesSave`;
 
    constructor(private httpHelper: HttpHelper) { }

    getSavedRatesResponse(scenId: number): Observable<IGrowthRatesSave> {
         return this.httpHelper.get(`${this._growthRatesSaveUrl}/${scenId}`)
            // .map((response: Response) => <IGrowthRatesSave> response.json())
            // .do(httpHelper => console.log('Growth rates save service: ' +  JSON.stringify(data)))
            // .catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/growth-rates-save/growth-rates-save.service.ts
 **/